import { render, staticRenderFns } from "./SupplyOfficial.vue?vue&type=template&id=15069619"
import script from "./SupplyOfficial.vue?vue&type=script&lang=js"
export * from "./SupplyOfficial.vue?vue&type=script&lang=js"
import style0 from "./SupplyOfficial.vue?vue&type=style&index=0&id=15069619&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports